var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_8812",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_8812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 13.2241V7.22412H25V13.2241H17ZM7 17.2241V7.22412H15V17.2241H7ZM17 25.2241V15.2241H25V25.2241H17ZM7 25.2241V19.2241H15V25.2241H7ZM9 15.2241H13V9.22412H9V15.2241ZM19 23.2241H23V17.2241H19V23.2241ZM19 11.2241H23V9.22412H19V11.2241ZM9 23.2241H13V21.2241H9V23.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.621c8c95c60ec807c159489d15ebf2cd.svg";
export { ForwardRef as ReactComponent };